import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ViewMessageReviewAdmin.css';
import ViewReviewAdminMessage from '../../components/ViewReviewAdminMessage';

class ViewMessageReviewAdminContainer extends React.Component {
  static propTypes = {
    threadId: PropTypes.number.isRequired,
    userType: PropTypes.string.isRequired
  };

  render() {
    const { threadId, userType } = this.props;


    return (
      <div>
        <div className={s.container}>
          <div className={s.root}>
            <ViewReviewAdminMessage threadId={threadId} userType={userType} />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ViewMessageReviewAdminContainer);
